import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import { useTheme, useMediaQuery, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

import withStyles from '@mui/styles/withStyles'

import NavigationBar from 'components/molecules/navigationBar'
import SideBar from 'components/molecules/sideBar'
import EnvBanner from 'components/atoms/envBanner'
import GlobalNotification from 'components/atoms/globalNotification'
import { PoweredByRCPAQAP } from 'components/atoms/corporationIcon'
import ErrorBoundary, { ContentErrorBoundary } from 'components/molecules/errorBoundary'
import AppVersion from 'components/molecules/appVersion'

import PreferenceTour from '../../tours/preferenceTour'
import { ENV_BANNER_ENABLED } from 'qap/constants'
import { styles } from './styles'

import type { ReactNode } from 'react'
import { useClientSettings } from 'hooks/clientSettings'
import { SidebarContext } from 'contexts/sidebar'

type Props = {
  children: ReactNode;
  classes: any;
};

const FooterContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 0.5rem;
`

// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
export const CommentTabContext = React.createContext<any>()

const HeaderSideBarLayout = (props: Props) => {
  const { classes, children } = props
  const theme = useTheme()
  const isWideScreen = useMediaQuery(theme.breakpoints.up('lg'))

  const {
    value: openSidebarPreference,
    updateSettings: updateSidebarPreference
  } = useClientSettings('openSidebarPreference')

  const [openSidebar, setOpenSidebar] = useState(false)
  const [commentsCollapsed, setCommentsCollapsed] = useState(null)

  useEffect(() => {
    // decide what the sidebar state should be based on screen size + preference
    if (isWideScreen) {
      setOpenSidebar(openSidebarPreference ?? true)
    } else {
      setOpenSidebar(false)
    }
  }, [isWideScreen, openSidebarPreference])

  const handleDrawerToggle = () => {
    const next = !openSidebar

    if (isWideScreen) {
      updateSidebarPreference(next)
    }

    setOpenSidebar(next)
  }

  return (
    <div className={classes.root}>
      <EnvBanner />
      <GlobalNotification />
      <PreferenceTour />
      <NavigationBar
// @ts-expect-error - TS2322 - Type '{ className: any; onDrawerToggle: () => void; openSidebar: boolean; }' is not assignable to type 'IntrinsicAttributes & Omit<Props, "classes"> & StyledComponentProps<"flex" | "root" | "toolbar" | "corporationIcon" | "navIcon" | "navIconHide" | "helpLink" | "notificationContainer" | "appBarShiftOpen" | "appBarShiftClose"> & object'.
        className={props.classes.header}
        onDrawerToggle={handleDrawerToggle}
        openSidebar={openSidebar}
      />
      <SideBar
        openSidebar={openSidebar}
        onDrawerToggle={handleDrawerToggle}
      />

      <main className={classnames(classes.main, { [classes.drawerOpen]: openSidebar, [classes.drawerClose]: !openSidebar })}>
        <div className={classes.toolbar} />
        <div className={classnames(classes.print, classes.content, classes.contentPadding, {
          [classes.envBannerMargin]: ENV_BANNER_ENABLED
        })}>
{ /* @ts-expect-error - TS2322 - Type '{ children: Element; component: JSXElementConstructor<any>; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<ErrorBoundary> & Readonly<Props> & Readonly<{ ...; }>'. */}
          <ErrorBoundary component={ContentErrorBoundary}>
            <CommentTabContext.Provider value={{
              commentsCollapsed,
              setCommentsCollapsed
            }}>
              <SidebarContext.Provider value={openSidebar}>
                {children}
              </SidebarContext.Provider>
            </CommentTabContext.Provider>
          </ErrorBoundary>
        </div>
      </main>
      <footer className={
        classnames(classes.footer, {
          [classes.expandedCommentPadding]: commentsCollapsed === false,
          [classes.collapsedCommentPadding]: commentsCollapsed
        })
      }>
        <FooterContainer>
          <Box>
            <PoweredByRCPAQAP className={classes.poweredBy} />
          </Box>
          <AppVersion />
        </FooterContainer>
      </footer>
    </div>
  )
}

// @ts-expect-error - TS2345 - Argument of type '(theme: any) => { root: { flexGrow: number; zIndex: number; overflow: string; position: string; backgroundColor: any; minHeight: string; }; main: { [x: number]: { marginLeft: number; }; '@media print': { marginTop: number; }; ... 4 more ...; display: string; }; ... 9 more ...; expandedCommentPadding: { ...; }; }' is not assignable to parameter of type 'Styles<any, any, string>'.
export default withStyles(styles)(HeaderSideBarLayout)
